import React, { useContext, useState } from "react";
import SizeBox from "../../../../../components/SizeBox";
import ButtonCustom from "../../../../../components/Button";
import { PUBLIC_URL } from "../../../../App/configs/Constants";
import { useDispatch, useSelector } from "react-redux";
import { dashboardPropertyChooseSelector } from "../../../selectors/DashboardSelectors";
import { DASHBOARD_PROPERTY_TYPE } from "../../../configs/DeclareTypes";
import { propertyStatusService } from "../../../services/DashboardServices";
import { toastError } from "../../../../../components/Toast";
import ModalCloseSchedule from "./Modal/ModalCloseSchedule";
import PropertyScanner from "./PropertyScanner";
import { LocalizationContext } from "../../../../../locales/Translation";
import { WORKSPACE_OPEN_STATUS } from "../../../configs/Constants";
import { dashboardPropertyListThunk } from "../../../thunks/DashboardThunks";
import { Popup } from "semantic-ui-react";

const PropertyStatus = () => {
  const { translations } = useContext(LocalizationContext);
  const dispatch = useDispatch();
  const dashboardPropertyChoose: DASHBOARD_PROPERTY_TYPE = useSelector(
    dashboardPropertyChooseSelector
  );

  const [loading, setLoading] = useState<boolean>(false);
  const [openCloseScheduleModal, setOpenCloseScheduleModal] =
    useState<boolean>(false);

  const _onOpenCloseProperty = async () => {
    try {
      setLoading(true);
      const property_id = dashboardPropertyChoose?.property_id;
      const payload = {
        property_id,
        is_open: dashboardPropertyChoose?.is_open ? 0 : 1,
      };
      await propertyStatusService(payload);
      // dispatch<any>(propertyStatusAction(property_id));
      await dispatch<any>(dashboardPropertyListThunk());
    } catch (e: any) {
      toastError(e?.status?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <SizeBox height={"27px"} />
        <div className={"dashboard_property_status_box"}>
          <div className={"d-flex"}>
            <h2 className={"dashboard_chart_title"}>
              {translations.propertyStatus}
            </h2>
            <Popup
              className={"input-label-text-guide"}
              content={
                "The property status was influenced by the operation time, future scheduled closures, public holidays, and the toggle button below"
              }
              trigger={
                <i
                  style={{ marginLeft: "8px" }}
                  className="uil uil-info-circle input-label-icon"
                />
              }
              position="top center"
            />
          </div>
          <SizeBox height={"12px"} />
          <div
            className={
              dashboardPropertyChoose?.opening_status?.id ===
              WORKSPACE_OPEN_STATUS.CLOSED
                ? "dashboard_property_status dashboard_property_status_close"
                : dashboardPropertyChoose?.opening_status?.id ===
                  WORKSPACE_OPEN_STATUS.OPEN_SOON
                ? "dashboard_property_status dashboard_property_status_open_soon"
                : "dashboard_property_status"
            }
          >
            • {dashboardPropertyChoose?.opening_status?.text}
          </div>
          <SizeBox height={"12px"} />
          <ButtonCustom
            loading={loading}
            className={"dashboard_property_close_btn"}
            onClick={_onOpenCloseProperty}
          >
            {dashboardPropertyChoose?.is_open
              ? translations.closePropertyForTheDay
              : translations.openProperty}
          </ButtonCustom>
          <SizeBox height={"12px"} />
          <div style={{ textAlign: "center" }}>
            <ButtonCustom
              className={"dashboard_property_review_btn"}
              onClick={() => {
                setOpenCloseScheduleModal(true);
              }}
            >
              <img src={PUBLIC_URL + "/assets/icons/icon-carbon-time.svg"} />
              <span>{translations.scheduleFutureClosures}</span>
            </ButtonCustom>
          </div>
        </div>

        <SizeBox height={"12px"} />
        <PropertyScanner />
      </div>
      <ModalCloseSchedule
        open={openCloseScheduleModal}
        setOpen={setOpenCloseScheduleModal}
      />
    </>
  );
};

export default PropertyStatus;
